import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const Providers = 'Providers'

export const getProviders = (filters) => {
  return axios.post(`/${Providers}/PaginatedAndFiltered`, filters)
}

export const getProvider = (id, headers= {}) => {
  return axios.get(`/${Providers}/${id}`,{headers})
}

export const updateProviderData = (data) => {
  return axios.post(`/${Providers}`, data)
}

export const uploadProviderDocuments = (data) => {
  return axios.post(`/${Providers}/Documents`, data)
}

export const sendProviderWarning = (data) => {
  return axios.post(`/${Providers}/Warning`, data)
}

export const removeProviderDocuments = (data) => {
  return axios.delete(`/${Providers}/Documents`, { data: data })
}
